module.exports = __webpack_public_path__ + "static/media/ic_safety.5f1532d7.svg";